// import React, { useState, useEffect, useCallback } from "react";
// import axios from "axios";
// import { useNavigate, useParams } from "react-router-dom";
// import { BiSave, BiX, BiBuilding } from "react-icons/bi";
// import { API_BASE_URL } from "../utils/urls.js";

// // --- Reusable Form Section ---
// const FormSection = ({ title, icon, children }) => (
//   <div className="border border-gray-200 rounded-xl p-4 sm:p-6 bg-white shadow-sm">
//     <h2 className="text-lg sm:text-xl font-extrabold text-blue-800 mb-4 flex items-center space-x-2 border-b pb-2">
//       {icon}
//       <span>{title}</span>
//     </h2>
//     <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">{children}</div>
//   </div>
// );

// const SuperAdminForm = () => {
//   const { id } = useParams();
//   const navigate = useNavigate();

//   // --- State for Organization Data ---
//   const [formData, setFormData] = useState({
//     name: "",
//     plan_type: "standard",
//     active_cases_limit: "",
//     user_limit: "",
//     billing_status: "trialing",
//   });

//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [submitStatus, setSubmitStatus] = useState("");

//   // --- Data Fetch ---
//   useEffect(() => {
//     const fetchOrganizationData = async () => {
//       const token = localStorage.getItem("token");
//       if (!token) {
//         setError("Authentication token not found.");
//         setLoading(false);
//         return;
//       }

//       try {
//         const orgRes = await axios.get(`${API_BASE_URL}/organizations/${id}`, {
//           headers: { Authorization: `Bearer ${token}` },
//         });
//         const orgData = orgRes.data;

//         setFormData({
//           name: orgData.name || "",
//           plan_type: orgData.plan_type || "standard",
//           active_cases_limit: orgData.active_cases_limit || "",
//           user_limit: orgData.user_limit || "",
//           billing_status: orgData.billing_status || "trialing",
//         });
//       } catch (err) {
//         console.error("Error fetching organization data:", err);
//         setError(err.response?.data?.message || "Failed to load data.");
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchOrganizationData();
//   }, [id]);

//   // --- Handlers ---
//   const handleChange = useCallback((e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   }, []);

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setSubmitStatus("submitting");
//     setError(null);
//     const token = localStorage.getItem("token");

//     try {
//       await axios.put(`${API_BASE_URL}/organizations/${id}`, formData, {
//         headers: { Authorization: `Bearer ${token}` },
//       });

//       setSubmitStatus("success");
//       setTimeout(() => navigate("/organizations"), 1500);
//     } catch (err) {
//       setSubmitStatus("error");
//       setError(err.response?.data?.message || "Submission failed.");
//     }
//   };

//   if (loading)
//     return <div className="p-6 text-center text-gray-600">Loading form...</div>;
//   if (error)
//     return <div className="p-6 text-center text-red-500 font-semibold">{error}</div>;

//   return (
//     <div className="px-4 sm:px-6 lg:px-8 py-6 max-w-4xl mx-auto w-full">
//       <h1 className="text-2xl sm:text-4xl font-extrabold text-gray-800 mb-6 sm:mb-8 text-center sm:text-left">
//         Edit Organization
//       </h1>

//       <form onSubmit={handleSubmit} className="space-y-6 sm:space-y-8">
//         <FormSection title="Organization Details" icon={<BiBuilding className="w-6 h-6" />}>
//           {/* Organization Name */}
//           <div className="col-span-full">
//             <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">
//               Organization Name *
//             </label>
//             <input
//               type="text"
//               id="name"
//               name="name"
//               value={formData.name}
//               onChange={handleChange}
//               required
//               className="p-2 sm:p-2.5 border rounded-md w-full focus:ring-2 focus:ring-blue-500 outline-none"
//             />
//           </div>

//           {/* Plan Type */}
//           <div>
//             <label htmlFor="plan_type" className="block text-sm font-medium text-gray-700 mb-1">
//               Plan Type *
//             </label>
//             <select
//               id="plan_type"
//               name="plan_type"
//               value={formData.plan_type}
//               onChange={handleChange}
//               className="p-2 sm:p-2.5 border rounded-md w-full focus:ring-2 focus:ring-blue-500 outline-none"
//             >
//               <option value="standard">Standard</option>
//               <option value="elite">Elite</option>
//             </select>
//           </div>

//           {/* Billing Status */}
//           <div>
//             <label htmlFor="billing_status" className="block text-sm font-medium text-gray-700 mb-1">
//               Billing Status *
//             </label>
//             <select
//               id="billing_status"
//               name="billing_status"
//               value={formData.billing_status}
//               onChange={handleChange}
//               className="p-2 sm:p-2.5 border rounded-md w-full focus:ring-2 focus:ring-blue-500 outline-none"
//             >
//               <option value="trialing">Trialing</option>
//               <option value="active">Active</option>
//               <option value="suspended">Suspended</option>
//               <option value="canceled">Canceled</option>
//             </select>
//           </div>

//           {/* User Limit */}
//           <div>
//             <label htmlFor="user_limit" className="block text-sm font-medium text-gray-700 mb-1">
//               User Limit
//             </label>
//             <input
//               type="number"
//               id="user_limit"
//               name="user_limit"
//               value={formData.user_limit}
//               onChange={handleChange}
//               className="p-2 sm:p-2.5 border rounded-md w-full focus:ring-2 focus:ring-blue-500 outline-none"
//             />
//           </div>

//           {/* Active Cases Limit */}
//           <div>
//             <label
//               htmlFor="active_cases_limit"
//               className="block text-sm font-medium text-gray-700 mb-1"
//             >
//               Active Cases Limit
//             </label>
//             <input
//               type="number"
//               id="active_cases_limit"
//               name="active_cases_limit"
//               value={formData.active_cases_limit}
//               onChange={handleChange}
//               className="p-2 sm:p-2.5 border rounded-md w-full focus:ring-2 focus:ring-blue-500 outline-none"
//             />
//           </div>
//         </FormSection>

//         {/* --- Buttons --- */}
//         <div className="flex flex-col sm:flex-row justify-end sm:space-x-4 space-y-3 sm:space-y-0 pt-4">
//           <button
//             type="button"
//             onClick={() => navigate("/organizations")}
//             className="px-5 py-2 text-sm font-medium text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300 transition w-full sm:w-auto"
//           >
//             <BiX className="inline-block w-5 h-5 mr-1" /> Cancel
//           </button>

//           <button
//             type="submit"
//             disabled={submitStatus === "submitting"}
//             className="px-5 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 disabled:opacity-50 transition w-full sm:w-auto"
//           >
//             <BiSave className="inline-block w-5 h-5 mr-1" /> Update Organization
//           </button>
//         </div>

//         {/* --- Status Messages --- */}
//         {submitStatus === "success" && (
//           <p className="mt-4 text-green-500 text-center font-semibold">
//             ✅ Organization updated successfully! Redirecting...
//           </p>
//         )}
//         {error && <p className="mt-4 text-red-500 text-center">{error}</p>}
//       </form>
//     </div>
//   );
// };

// export default SuperAdminForm;


import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { BiSave, BiX, BiBuilding } from "react-icons/bi";
import { API_BASE_URL } from "../utils/urls.js";

// --- Reusable Form Section ---
const FormSection = ({ title, icon, children }) => (
  <div className="border border-gray-200 rounded-xl p-4 sm:p-6 bg-white shadow-sm">
    <h2 className="text-lg sm:text-xl font-extrabold text-blue-800 mb-4 flex items-center space-x-2 border-b pb-2">
      {icon}
      <span>{title}</span>
    </h2>
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">{children}</div>
  </div>
);

const SuperAdminForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  // --- State for Organization Data ---
  const [formData, setFormData] = useState({
    name: "",
    org_address: "", // Added org_address state
    plan_type: "standard",
    active_cases_limit: "",
    user_limit: "",
    billing_status: "trialing",
    logo_url: "",
  });

  const [logoFile, setLogoFile] = useState(null); 
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [submitStatus, setSubmitStatus] = useState("");

  // --- Data Fetch ---
  useEffect(() => {
    const fetchOrganizationData = async () => {
      const token = localStorage.getItem("token");
      if (!token) {
        setError("Authentication token not found.");
        setLoading(false);
        return;
      }

      try {
        const orgRes = await axios.get(`${API_BASE_URL}/organizations/${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const orgData = orgRes.data;

        setFormData({
          name: orgData.name || "",
          org_address: orgData.org_address || "", // Fetch org_address
          plan_type: orgData.plan_type || "standard",
          active_cases_limit: orgData.active_cases_limit || "",
          user_limit: orgData.user_limit || "",
          billing_status: orgData.billing_status || "trialing",
          logo_url: orgData.logo_url || "", 
        });
      } catch (err) {
        console.error("Error fetching organization data:", err);
        setError(err.response?.data?.message || "Failed to load data.");
      } finally {
        setLoading(false);
      }
    };

    fetchOrganizationData();
  }, [id]);

  // --- Handlers ---
  const handleChange = useCallback((e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  }, []);

  // Handle Logo File Selection
  const handleFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setLogoFile(e.target.files[0]);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitStatus("submitting");
    setError(null);
    const token = localStorage.getItem("token");

    try {
      // 1. Update text data (now includes org_address)
      await axios.put(`${API_BASE_URL}/organizations/${id}`, formData, {
        headers: { Authorization: `Bearer ${token}` },
      });

      // 2. Upload Logo if a new one was selected
      if (logoFile) {
        const formUpload = new FormData();
        formUpload.append("logo", logoFile);

        await axios.post(`${API_BASE_URL}/organizations/${id}/logo`, formUpload, {
          headers: { 
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data" 
          },
        });
      }

      setSubmitStatus("success");
      setTimeout(() => navigate("/organizations"), 1500);
    } catch (err) {
      setSubmitStatus("error");
      setError(err.response?.data?.message || "Submission failed.");
    }
  };

  if (loading)
    return <div className="p-6 text-center text-gray-600">Loading form...</div>;
  if (error)
    return <div className="p-6 text-center text-red-500 font-semibold">{error}</div>;

  return (
    <div className="px-4 sm:px-6 lg:px-8 py-6 max-w-4xl mx-auto w-full">
      <h1 className="text-2xl sm:text-4xl font-extrabold text-gray-800 mb-6 sm:mb-8 text-center sm:text-left">
        Edit Organization
      </h1>

      <form onSubmit={handleSubmit} className="space-y-6 sm:space-y-8">
        <FormSection title="Organization Details" icon={<BiBuilding className="w-6 h-6" />}>
          
          {/* Organization Name */}
          <div className="col-span-full">
            <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">
              Organization Name *
            </label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              className="p-2 sm:p-2.5 border rounded-md w-full focus:ring-2 focus:ring-blue-500 outline-none"
            />
          </div>

          {/* Organization Address (NEW FIELD) */}
          <div className="col-span-full">
            <label htmlFor="org_address" className="block text-sm font-medium text-gray-700 mb-1">
              Organization Address
            </label>
            <textarea
              id="org_address"
              name="org_address"
              value={formData.org_address}
              onChange={handleChange}
              rows="3"
              placeholder="e.g. 123 Main St, Suite 400, City, State, ZIP"
              className="p-2 sm:p-2.5 border rounded-md w-full focus:ring-2 focus:ring-blue-500 outline-none resize-none"
            ></textarea>
          </div>

          {/* Logo Upload */}
          <div className="col-span-full border-t border-b py-4 my-2 border-gray-100">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Organization Logo
            </label>
            <div className="flex items-center space-x-4">
              {formData.logo_url && !logoFile && (
                <img 
                  src={`${API_BASE_URL.replace('/api', '')}${formData.logo_url}`} 
                  alt="Current Logo" 
                  className="w-16 h-16 object-contain border rounded bg-gray-50"
                />
              )}
              <input
                type="file"
                accept="image/*"
                onChange={handleFileChange}
                className="p-2 text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
              />
            </div>
          </div>

          {/* Plan Type */}
          <div>
            <label htmlFor="plan_type" className="block text-sm font-medium text-gray-700 mb-1">
              Plan Type *
            </label>
            <select
              id="plan_type"
              name="plan_type"
              value={formData.plan_type}
              onChange={handleChange}
              className="p-2 sm:p-2.5 border rounded-md w-full focus:ring-2 focus:ring-blue-500 outline-none"
            >
              <option value="standard">Standard</option>
              <option value="pro">Pro</option>
              <option value="elite">Elite</option>
            </select>
          </div>

          {/* Billing Status */}
          <div>
            <label htmlFor="billing_status" className="block text-sm font-medium text-gray-700 mb-1">
              Billing Status *
            </label>
            <select
              id="billing_status"
              name="billing_status"
              value={formData.billing_status}
              onChange={handleChange}
              className="p-2 sm:p-2.5 border rounded-md w-full focus:ring-2 focus:ring-blue-500 outline-none"
            >
              <option value="trialing">Trialing</option>
              <option value="active">Active</option>
              <option value="exempt">Subscription Exempt</option>
              <option value="suspended">Suspended</option>
              <option value="canceled">Canceled</option>
            </select>
          </div>

          {/* User Limit */}
          <div>
            <label htmlFor="user_limit" className="block text-sm font-medium text-gray-700 mb-1">
              User Limit
            </label>
            <input
              type="number"
              id="user_limit"
              name="user_limit"
              value={formData.user_limit}
              onChange={handleChange}
              className="p-2 sm:p-2.5 border rounded-md w-full focus:ring-2 focus:ring-blue-500 outline-none"
            />
          </div>

          {/* Active Cases Limit */}
          <div>
            <label
              htmlFor="active_cases_limit"
              className="block text-sm font-medium text-gray-700 mb-1"
            >
              Active Cases Limit
            </label>
            <input
              type="number"
              id="active_cases_limit"
              name="active_cases_limit"
              value={formData.active_cases_limit}
              onChange={handleChange}
              className="p-2 sm:p-2.5 border rounded-md w-full focus:ring-2 focus:ring-blue-500 outline-none"
            />
          </div>
        </FormSection>

        {/* --- Buttons --- */}
        <div className="flex flex-col sm:flex-row justify-end sm:space-x-4 space-y-3 sm:space-y-0 pt-4">
          <button
            type="button"
            onClick={() => navigate("/organizations")}
            className="px-5 py-2 text-sm font-medium text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300 transition w-full sm:w-auto"
          >
            <BiX className="inline-block w-5 h-5 mr-1" /> Cancel
          </button>

          <button
            type="submit"
            disabled={submitStatus === "submitting"}
            className="px-5 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 disabled:opacity-50 transition w-full sm:w-auto"
          >
            <BiSave className="inline-block w-5 h-5 mr-1" /> Update Organization
          </button>
        </div>

        {/* --- Status Messages --- */}
        {submitStatus === "success" && (
          <p className="mt-4 text-green-500 text-center font-semibold">
            ✅ Organization updated successfully! Redirecting...
          </p>
        )}
        {error && <p className="mt-4 text-red-500 text-center">{error}</p>}
      </form>
    </div>
  );
};

export default SuperAdminForm;
